var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpopup",class:{ show: _vm.showState }},[_c('div',{staticClass:"cpp-bg",on:{"click":_vm.hide}}),_c('div',{staticClass:"cpp-content"},[_c('div',{staticClass:"cpp-close",on:{"click":_vm.hide}},[_c('i',{staticClass:"common-icon-close"})]),_c('div',{ref:"slot",staticClass:"cpp-slot"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }